export enum TABLES {}

export enum SORT_ORDERS {
    ASC = "ASC",
    DESC = "DESC",
}

export const STORAGE_KEY = "ilyakoorakey";
